import * as Yup from 'yup'


export const verifyAndConfirmAccountSchema = Yup.object().shape({
    code: Yup.string().required('Access Code is Required'),
    email: Yup.string().email('Invalid email').required('Required'),
})